export default __webpack_public_path__ + "static/du-logo-4ab66fab0f2209eea4dc6d771874b7c6.png";